import { Component } from "@angular/core";
import { RouterOutlet, RouterLink } from "@angular/router";
import { FacultyAdminWelcomeComponent } from "./welcome/welcome.component";
import { ResetPassDialogComponent } from "../authentication/reset-pass-dialog/reset-pass-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-faculty-admin-dashboard",
  standalone: true,
  templateUrl: "./faculty-admin-dasboard.component.html",
  styleUrl: "./faculty-admin-dasboard.component.scss",
  imports: [FacultyAdminWelcomeComponent, RouterOutlet, RouterLink],
})
export class FacultyAdminDasboardComponent {
  constructor(private dialog: MatDialog) {}
  ngOnInit(): void {
    const storedUser = sessionStorage.getItem("currentUser");
    const user = storedUser ? JSON.parse(storedUser) : null;
    if (user && user.shouldRenewPassword) {
      this.onPassChange();
    }
  }
  private onPassChange() {
    const dialogConfig = this.dialog.open(ResetPassDialogComponent, {
      minWidth: "650px",
      width: "800px",
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogConfig.afterClosed().subscribe((results) => {});
  }
}
